<template>
  <div class="text-left" style="height:550px; overflow-y:auto;">
    <b-form>
      <b-row>
        <b-col cols="6">
          <b-form-group label="First Name:">
            <b-form-input
              v-model="$v.form.firstName.$model"
              :state="$v.form.firstName.$dirty ? !$v.form.firstName.$error : null"
              type="text"
              placeholder="Enter First Name"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="6">
          <b-form-group label="Last Name:">
            <b-form-input
              v-model="$v.form.lastName.$model"
              :state="$v.form.lastName.$dirty ? !$v.form.lastName.$error : null"
              type="text"
              placeholder="Enter Last Name"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group label="Email:">
            <b-form-input
              v-model="$v.form.email.$model"
              :state="$v.form.email.$dirty ? !$v.form.email.$error : null"
              type="email"
              placeholder="Enter Email"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="6">
          <b-form-group label="Country">
            <v-select
              :searchable="false"
              :clearable="false"
              :multiple="false"
              label="name"
              :class="$v.form.country.$error ? 'border border-danger rounded' : null"
              v-model="$v.form.country.$model"
              :state="$v.form.country.$dirty ? !$v.form.country.$error : null"
              :options="countryOptions"
              :value="'name'"
            >
              <template slot="option" slot-scope="option">
                <country-flag v-if="option.icon" :country="option.icon" size="small" />
                <span>{{ '&nbsp;'+ option.name }}</span>
              </template>
            </v-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group label="Select Company">
            <v-select
              :searchable="false"
              :clearable="false"
              :multiple="false"
              :class="$v.form.company.$error ? 'border border-danger rounded' : null"
              v-model="$v.form.company.$model"
              :state="$v.form.company.$dirty ? !$v.form.company.$error : null"
            ></v-select>
          </b-form-group>
        </b-col>

        <b-col cols="6">
          <b-form-group label="Select Sectors">
            <v-select
              :searchable="false"
              :clearable="false"
              :multiple="false"
              :class="$v.form.sectors.$error ? 'border border-danger rounded' : null"
              v-model="$v.form.sectors.$model"
              :state="$v.form.sectors.$dirty ? !$v.form.sectors.$error : null"
            ></v-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group label="User Group">
            <v-select
              :searchable="false"
              :clearable="false"
              :multiple="false"
              :class="$v.form.userGroup.$error ? 'border border-danger rounded' : null"
              v-model="$v.form.userGroup.$model"
              :state="$v.form.userGroup.$dirty ? !$v.form.userGroup.$error : null"
            ></v-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-card header="Note : For Sonova & Dyson & STE" header-tag="header">
            <b-form-checkbox v-model="form.steApprover" value="1" unchecked-value="0">Approver</b-form-checkbox>
          </b-card>
        </b-col>

        <b-col cols="6">
          <b-card header="Note : For OLAM" header-tag="header">
            <b-form-checkbox v-model="form.olamApprover" value="1" unchecked-value="0">Approver</b-form-checkbox>
            <b-form-checkbox
              v-model="form.olamFinalClassifier"
              value="1"
              unchecked-value="0"
            >Final Classifier</b-form-checkbox>
          </b-card>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-card header="Permission for Upload Remediation Report" header-tag="header">
            <b-form-checkbox
              v-model="form.remediationPermission"
              value="1"
              unchecked-value="0"
            >Remediation Permission</b-form-checkbox>
          </b-card>
        </b-col>

        <b-col cols="6">
          <b-card header="Permission to see only own Third Parties" header-tag="header">
            <b-form-checkbox
              v-model="form.thirdPartiesPermission"
              value="1"
              unchecked-value="0"
            >Third Parties Permission</b-form-checkbox>
          </b-card>
        </b-col>
      </b-row>
      <div class="text-right mt-4">
        <b-button @click="submitForm" variant="outline-success">Save</b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
// import { HTTP } from "../../utils/HTTP";
import vSelect from "vue-select";
import CountryCodes from "../../utils/countryCodes.json";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  name: "ClientProfileAddUser",
  mixins: [validationMixin],
  components: {
    vSelect
  },
  data() {
    return {
      form: {
        firstName: null,
        lastName: null,
        email: null,
        country: null,
        company: null,
        sectors: null,
        userGroup: null,
        steApprover: null,
        olamApprover: null,
        olamFinalClassifier: null,
        remediationPermission: null,
        thirdPartiesPermission: null
      },
      countryOptions: CountryCodes.countries
    };
  },

  validations: {
    form: {
      firstName: {
        required
      },
      lastName: {
        required
      },
      email: {
        required
      },
      country: {
        required
      },
      company: {
        required
      },
      sectors: {
        required
      },
      userGroup: {
        required
      }
    }
  },

  computed: {},
  mounted() {},
  methods: {
    submitForm() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
    }
  }
};
</script>

<style scoped>
</style>
